'use strict';

/* globals yith_wcaf, yith */

import { $ } from '../../../src/globals.js';
import YITH_WCAF_Ajax from '../../../src/modules/ajax';

export default class YITH_WCAF_Admin_Notes {
	// container element.
	$container;

	// object type
	objectType;

	// object ID
	objectID;

	constructor( $container, objectType, objectID ) {
		if ( ! $container?.length ) {
			return;
		}

		this.$container = $container;
		this.objectType = objectType;
		this.objectID = objectID;
		this.$notesList = this.$container.find( '.order_notes' );
		this.$addButton = this.$container.find( '#add_note' );
		this.$noteContent = this.$container.find( '#add_order_note' );
		this.$emptyMsg = this.$notesList.find( '.no_notes' );

		this.init();
	}

	init() {
		const self = this;

		this.$container.on( 'click', '.delete_note', function ( ev ) {
			ev.preventDefault();

			const $note = $( this ).closest( '.note' );

			self.deleteNote( $note );
		} );

		this.$addButton.on( 'click', function ( ev ) {
			ev.preventDefault();

			const content = self.$noteContent.val();

			if ( ! content ) {
				self.$noteContent.parent().addClass( 'woocommerce-invalid' );
			} else {
				self.addNote( content );
			}
		} );

		this.$noteContent.on( 'keyup', function () {
			const content = self.$noteContent.val();

			if ( content ) {
				self.$noteContent.parent().removeClass( 'woocommerce-invalid' );
			}
		} );
	}

	addNote( note ) {
		YITH_WCAF_Ajax.post
			.call( this.$container, 'add_note', 'add_note', {
				object_id: this.objectID,
				object_type: this.objectType,
				note_content: note,
			} )
			.done( ( data ) => {
				if ( ! data?.success ) {
					return;
				}

				if ( data?.data?.template ) {
					const $newNote = $( data.data.template );

					this.$notesList.prepend( $newNote );
					this.$noteContent.val( '' );
					this.$emptyMsg.hide();
					$newNote.get( 0 ).scrollIntoView();
				}
			} );
	}

	deleteNote( $note ) {
		YITH_WCAF_Ajax.post
			.call( $note, 'delete_note', 'delete_note', {
				object_id: this.objectID,
				object_type: this.objectType,
				note_id: $note.attr( 'rel' ),
			} )
			.done( ( data ) => {
				if ( ! data?.success ) {
					return;
				}

				$note.remove();

				if (
					! this.$notesList.find( 'li' ).not( this.$emptyMsg ).length
				) {
					this.$emptyMsg.show();
				}
			} );
	}
}
